import { useAuthState } from '@contexts/AuthContext';
import { BASE_URL } from '@shared/frontendEnv';
import useToast from '../../hooks/useToast';

const useCopyReferral = () => {
  const { harvesterToken } = useAuthState();
  const toast = useToast();

  const copyReferral = () => {
    if (!harvesterToken) {
      toast.error('Your account has no referral link.');
      return;
    }
    navigator.clipboard
      .writeText(`${BASE_URL}/referral/${harvesterToken}`)
      .then(() => toast.success('Referral link copied to clipboard!'))
      .catch(() => toast.error('Failed to copy the link.'));
  };

  return { canCopyReferral: !!harvesterToken, copyReferral };
};

export default useCopyReferral;
